export default "__VITE_ASSET__BxG8VGOP__"